<script>
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";

// Editor twin always draws its contents so they stay editable; staging uses the engine's HoverVisible.
export default {
  name: "HoverVisibleContainer",
  extends: Container,
  elementPanelSettings: {
    alias: "Shown On Hover",
    displayName: "Shown On Hover",
    displayIcon: "mdi:eye-outline",
    tags: ["container", "hover", "reveal", "actions"],
  },
  hidden: true,
  optionBundles: [
    new LayoutPositionOptions({
      "default.static-layout-direction": "horizontal",
    }),
    SpacingOptions,
    AppearanceOptions,
  ],
};
</script>
